import { Model } from '@ofqual/portal-core/core/types';
import { ConflictInterestModel } from './ConflictInterestModel';
import { PersonalDetailsModel } from './PersonalDetailsModel';
import { QualificationModel } from './QualificationModel';
import { SelfDeclarationModel } from './SelfDeclarationModel';
import { IndustryExpertiseModel } from './IndustryExpertiseModel';
import { AssessmentExpertiseModel } from './AssessmentExpertiseModel';
import { ProfessionalMembershipModel } from './ProfessionalMembershipModel';
import { ReferenceModel } from './ReferenceModel';
import { CommunicationJudgementModel } from './CommunicationJudgementModel';
import { WorkHistoryModel } from './WorkHistoryModel';
import { SupportingEvidenceExpertiseModel } from './SupportingEvidenceExpertiseModel';
import { SubjectModel } from './SubjectModel';
import { TeachingExpertiseModel } from './TeachingExpertiseModel';

export enum SubTaskStatus {
 Completed = 1,
 InProgress = 2,
 NotStarted = 3,
 CannotStartYet = 4,
}

export enum ApplicationStatus {
 'Not submitted' = 0,
 'Submitted' = 1,
 'Ready to submit' = 2,
 'Ready for evaluation' = 3,
 'More evidence requested - Evaluation' = 7,
 'Evaluation approved' = 8,
 'Evaluation unsuccessful' = 9,
 'Evaluation partially approved' = 10,
 'Admin approved' = 11,
 'Admin unsuccessful' = 12,
 'Admin partially approved' = 13
 }


export type ExpertsApplyModel = {
 id: string;
 referenceNumber: string;
 govUkId: string;
 createdDate: string;
 modifiedDate: string;
 createdByUPN: string;
 createdByDisplayName: string;
 modifiedByUPN: string;
 modifiedByDisplayName: string;
 qualificationDetailsStatus: SubTaskStatus;
 hasRelevantQualifications: boolean;
 qualifications: QualificationModel[];
 hasProfessionalMembership: boolean;
 personalDetails: PersonalDetailsModel;
 selfDeclaration: SelfDeclarationModel;
 industryExpertise: IndustryExpertiseModel;
 assessmentExpertise: AssessmentExpertiseModel;
 teachingExpertise: TeachingExpertiseModel;
 professionalMemberships: ProfessionalMembershipModel[];
 hasConflictOfInterest: boolean;
 conflictInterests: ConflictInterestModel[];
 references: ReferenceModel[];
 communicationJudgement: CommunicationJudgementModel;
 supportingEvidenceExpertise: SupportingEvidenceExpertiseModel;
 roles: WorkHistoryModel[];
 subjects: SubjectModel[];
 submittedDate?: string;
 approvedDate?: string;
 renewalDate?: string;
 applicationStatus: ApplicationStatus;
 rightToWork?: boolean;
 assignedTo: string[];
 referencesRequested?: boolean;
 referencesValid?: boolean;
 AnalyticalJudgementskills?:boolean
};

export const fromApiModel = (model: Model): ExpertsApplyModel => {
 return {
  ...model,
 } as ExpertsApplyModel;
};

export const toApiModel = (item: ExpertsApplyModel): Model => {
 return {
  ...item,
 } as Model;
};
export interface InternalMessageModel {
 documents: File[];
 subject: string;
 message: string;
 recipients: Recipient[];
}

export interface Recipient {
 id: string;
 name: string;
}
